export default "__VITE_ASSET__4hsattUd__"